import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=199ace97&scoped=true&"
import script from "./DetailDialog.vue?vue&type=script&lang=ts&"
export * from "./DetailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ace97",
  null
  
)

export default component.exports